// extracted by mini-css-extract-plugin
export default {"link":"sN-z","disabled":"tN-z"};